import React from 'react'
import './TodosLoading.css'
function TodosLoading() {

  return (<div className='loadingDiv'>
<p>cargando... </p> 
<span className="loader"></span> 
</div>)
}

export {TodosLoading}